import React, { useEffect, useState } from 'react';
import { useSharedContext } from '../../context/SharedContext';
import { AuthenticatedUser } from '../../security/auth/AuthenticatedUser';
import { ShopifySupportApi } from '../../api/ShopifySupportApi';
import { Alerter } from '../../layout/Alerter';
import { OrderDto } from '../../api/dto/OrderDto';
import { useQuery } from '@tanstack/react-query';


export default function Home() {

    const MaxDays: number = 5;

    const sharedContextData = useSharedContext();

    //const [orderItems, setOrderItems] = useState<OrderDto[] | null>(null);

    const [loggedIn, setLoggedIn] = useState<boolean>(false)

    // const loadOrderItems = async (user: AuthenticatedUser) => {
    //     const lookup = await ShopifySupportApi.getOrders(MaxDays, user);
    //     if (lookup) {
    //         if (lookup.length > 5) {
    //             setOrderItems(lookup.slice(0, 5));
    //         } else {
    //             setOrderItems(lookup);
    //         }
    //     } else {
    //         Alerter.showError('Error encountered while loading order items', Alerter.DEFAULT_TIMEOUT);
    //         setOrderItems([]);
    //     }
    // }

    // useEffect(() => {
    //     const user = sharedContextData.getAuthenticatedUser();
    //     if (user != null) {
    //         setLoggedIn(true)
    //
    //         loadOrderItems(user)
    //             .catch(() => {
    //                 console.log("Error loading order items")
    //             });
    //     }
    //
    // }, []);

    const getAuthenticatedUser = (): Promise<AuthenticatedUser> => {
        return new Promise<AuthenticatedUser>((resolve, reject) => {
            const result = sharedContextData.getAuthenticatedUser();
            if (result == null) {
                reject("Unable to find authenticated user");
            }
            resolve(result!);
        });
    }

    const {data: authenticatedUser, isLoading: isLoadingAuthenticatedUser } = useQuery({
        queryKey: ["authenticatedUser"],
        queryFn: getAuthenticatedUser,
        enabled: true,
        retry: true,
        retryDelay: 500,
        //refetchInterval: (data) => (data === null ? 5000 : false),
    });

    const loadOrders = async (days: number, user: AuthenticatedUser): Promise<OrderDto[]> => {
        return new Promise<OrderDto[]>(async (resolve, reject) => {
            const result = await ShopifySupportApi.getOrders(days, user);
            if (result == null) {
                reject("Unable to find orders");
            } else {
                // @ts-ignore
                resolve(result);
            }
        });
    }

    const {data: orders, isLoading: isLoadingOrders } = useQuery({
        queryKey: ["orders", 3],
        queryFn: () => loadOrders(3, authenticatedUser!),
        retry: 3,
        retryDelay: 500,
        enabled: !!authenticatedUser
    });

    if (isLoadingAuthenticatedUser) {
        return (
            <div>
                Loading authenticated user....
                <div className="ca-spinner-box spinner-border text-primary"><span className="sr-only"></span></div>
            </div>
        );
    }

    if (isLoadingOrders) {
        return (
            <div>
                Loading orders for last few days....
                <div className="ca-spinner-box spinner-border text-primary"><span className="sr-only"></span></div>
            </div>
        );
    }

    return(
        <div>
            <h2><span className="ca-blue">Make My Cap</span></h2>
            {
                orders == null &&
                <div className="mmc-red text-primary">Unable to load orders</div>
            }
            {
                orders != null &&
                <div>
                    <div className="mmc-tabular-data-container">
                        <table className="table table-striped table-hover">
                            <thead className="table-dark">
                            <tr>
                                <th>Order Id</th>
                                <th>Order Number</th>
                                <th>DeliverTo Name</th>
                                <th>DeliverTo City</th>
                                <th># Items</th>
                                <th># PoItems</th>
                                <th>Created Date</th>
                                <th>Process Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                (orders).map(function (item) {
                                    return (
                                        <tr key={item.orderId}>
                                            <td>{item.orderId}</td>
                                            <td>{item.orderNumber}</td>
                                            <td>{item.deliverToName}</td>
                                            <td>{item.deliverToCity}</td>
                                            <td>{item.orderItems.length}</td>
                                            <td>{item.purchaseOrderItems.length}</td>
                                            <td>{item.createdDateTime}</td>
                                            <td>{item.processStartDateTime}</td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            }
        </div>
    );
}
